import { NavLink } from '@montebravo.tech/design-system-navigation';

export const NAV_LINKS: NavLink[] = [
    { id: 'home', label: 'Início', link: '/onboarding', icon: 'home' },
];
